import { fork, all } from 'redux-saga/effects';
import * as consultLogs from './logSagas';
export default function* rootSaga() {
  yield all([...Object.values(consultLogs)].map(fork));
}
